const IDs = {
    myLorryBids: {
        attachLorry: "myLorryBids_btn_attachLorry"
    },
    updateDriverDetailsModal: {
        nameInput: "updateVehicleDetails_txtf_driverName",
        numberInput: "updateVehicleDetails_txtf_driverNumber",
        selectMenu: "updateVehicleDetails_drpd_lorryNumber",
        viewTrip: "updateVehicleDetails_lnk_view",
        updateDetails: "updateVehicleDetails_btn_updateDetails",
        modalClose: "updateVehicleDetails_btn_closeIcon",
        cancelBtn: "updateVehicleDetails_btn_cancelBtn"
    },
    postingForm: {
        selectAllState: "postingForm_btn_selectAllState",
        selectType: {
            body: "select_body",
            feet: "select_feet",
            capacity: "select_capacity",
            tyres: "select_tyres",
            lorry: "select_lorry"
        },
        src: "postingForm_txtf_src",
        dest: "postingForm_txtf_dest",
        location: "location",
        materialType: "postingForm_drpd_materialType",
        materialName: "postingForm_txtf_materialName",
        quantity: "postingForm_txtf_quantity",
        quantityChip: "postingForm_txtf_quantityChip",
        capacity: "postingForm_txtf_capacity",
        expectedAmount: "postingForm_expectedAmount",
        paymentToPay: "postingForm_btn_paymentToPay",
        paymentAdvance: "postingForm_btn_paymentAdvance",
        reportingTime: "postingForm_btn_reportingTime",
        submitBtn: "postingForm_btn_submit",
        closeBtn: "postingForm_btn_close",
        isOdc: "isOdc",
        bodyTypeFilter: "bodyTypeFilter"
    },
    bidForm: {
        bidPrice: "bidForm_price",
        bidRemarks: "bidForm_txtf_remarks",
        bidPriceTypeAsFixed: "bidForm_btn_fixedPrice",
        bidPriceTypeAsPerTonne: "bidForm_btn_perTonner",
        bidPriceIsNegotiable: "bidForm_btn_negotiable",
        bidPriceToBill: "bidForm_btn_toBill",
        bidPriceToPay: "bidForm_btn_toPay",
        bidFormVehicleNumber: "bidForm_txtf_vehicleNumber",
        bidFormVehicleNumberErrorMessage: "bidForm_txtf_vehicleNumberErrorMessage",
        bidFormBidNowButton: "mktplace_load_bid_final_submit_btn",
        bidForm_btn_close: "bidForm_btn_close",
        bidForm_companyName: "bidForm_companyName"
    },
    dashboard: {
        postLoadLorryBtn: "dashboard_btn_post",
        profileBtn: "dashboard_btn_profile",
        myProfile: "dashboard_btn_myProfile"
    },
    csDashboard: {
        sendWa: "dashboard_btn_sendWa",
        blockUser: "dashboard_btn_blockUser"
    },
    common: {
        navbar: "dashboard_nav",
        vahakLogo: "dashboard_link_vahakLogo"
    },
    header: {
        services: "header_nav_services",
        marketplace: "header_nav_marketplace",
        transportDirectory: "header_nav_transportDirectory",
        meetVahak: "header_nav_meetVahak",
        onlineLoadBooking: "header_nav_onlineLoadBooking",
        onlineLorryBooking: "header_nav_onlineLorryBooking",
        growNetwork: "header_nav_growNetwork",
        logisticsServices: "header_nav_logisticsServices",
        fullTruckLoad: "header_nav_fullTruckLoad",
        partLoadBooking: "header_nav_partLoadBooking",
        cargoInsurance: "header_nav_cargoInsurance",
        commercialVehicleInsurance: "header_nav_commercialVehicleInsurance",
        businessLoan: "header_nav_businessLoan",
        forum: "header_nav_forum",
        aboutUs: "header_nav_aboutUs",
        howVahakHelps: "header_nav_howVahakHelps",
        whyChooseUs: "header_nav_whyChooseUs",
        careers: "header_nav_careers",
        contactUs: "header_nav_contactUs",
        resources: "header_nav_resources",
        profileAvatar: "header_nav_profileAvatar",
        myProfile: "header_nav_myProfile",
        membership: "header_nav_membership",
        productsAndServices: "header_nav_productsAndServices",
        serviceSelection: "header_nav_serviceSelection",
        productsAndServicesSubMenu: {
            gps: "header_nav_productsAndServices_gps",
            cargoInsurance: "header_nav_productsAndServices_cargoInsurance",
            vehicleInsurance: "header_nav_productsAndServices_vehicleInsurance",
            businessLoan: "header_nav_productsAndServices_businessLoan"
        }
    },
    marketPlace: {
        marketPlaceCard: "marketPlaceCard",
        pageLeft: "pageLeft",
        pageRight: "pageRight"
    },
    auth: {
        loginModal: "auth_modal",
        submitBtn: "auth_btn_submit",
        crossBtn: "auth_btn_cross",
        helpDesk: "helpdesk__btn",
        phoneNumber: "auth_textf_phoneNumber",
        editPhoneNumber: "auth_textf_editPhoneNumber",
        otp: "auth_textf_otp",
        serviceType: "auth_ms_serviceType",
        userName: "auth_text_userName",
        locationInput: "auth_drpd_location",
        currentLocation: "auth_ms_currentLocation",
        referralToggleBtn: "auth_ms_referralToggleBtn",
        referralInput: "auth_text_referral",
        postLoad: "auth_btn_postLoad",
        postLorry: "auth_btn_postLorry",
        resendBtn: "auth_btn_resend",
        resendBtnSms: "auth_btn_resend-sms",
        resendBtnWa: "auth_btn_resend-wa",
        optWa: "auth_btn_optWa"
    },
    bidCard: {
        bidCard: "bidCard",
        viewDetailsCta: "viewDetailsCta"
    },
    profileDropDown: {
        profileLogout: "profile_logout",
        profileDropdownBtn: "profile_dropdown_btn",
        myProfileBtn: "my_profile_btn"
    }
};

export { IDs };
//# sourceMappingURL=automation.js.map
